module.exports = __webpack_public_path__ + "img/20240918154049987cpq.4132bc9f.jpg";